define(function () {

    'use strict';

    return {
        "items": [
            {
                "attrs": {
                    "id": "landing"
                },
                "label": {
                    "EN": "Data Management",
                    "FR": "Gestion des Données"
                }
            },
            {
                "attrs": {
                    "id": "search"
                },
                "label": {
                    "EN": "Search",
                    "FR": "Rechercher"
                }
            },
            {
                "attrs": {
                    "id": "add"
                },
                "label": {
                    "EN": "Add",
                    "FR": "Ajouter"
                }
            },
            {
                "attrs": {
                    "id": "home"
                },
                "label": {
                    "EN": "Home",
                    "FR": "Accueil"
                }
            },
            {
                "attrs": {
                    "id": "metadata"
                },
                "label": {
                    "EN": "Metadata",
                    "FR": "Métadonnées"
                }
            },
            {
                "attrs": {
                    "id": "dsd"
                },
                "label": {
                    "EN": "DSD",
                    "FR": "DSD"
                }
            },
            {
                "attrs": {
                    "id": "data"
                },
                "label": {
                    "EN": "Data",
                    "FR": "Données"
                }
            },
            {
                "attrs": {
                    "id": "delete"
                },
                "label": {
                    "EN": "Delete",
                    "FR": "Supprimer"
                }
            },
            {
                "attrs": {
                    "id": "close"
                },
                "label": {
                    "EN": "Close",
                    "FR": "Terminer"
                }
            }
        ],
        "languages": [],
        "active": [
            "landing",
            "search"
        ]
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/config/menu.js
// module id = 39
// module chunks = 0